import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import Loading from "../Common/Loading";
import { useSellerAuth } from "../Common/SellerAuthContext";

export default function SellerProtectedRoute({ children }) {
  const location = useLocation();
  const { isSellerAuthenticated, sellerLoading } = useSellerAuth();

  if (sellerLoading) {
    return <Loading />;
  }

  if (!isSellerAuthenticated) {
    return (
      <Navigate
        replace
        to="/sellerhome"
        state={{ sellerRedirectPath: location.pathname }}
      />
    );
  }

  return children;
}
